export function calculateAge(date) {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    let ageDiffMs = Date.now() - date.getTime();
    var ageDate = new Date(ageDiffMs); // miliseconds from epoch
    console.log(ageDate);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}
